package view

import com.soywiz.klock.milliseconds
import com.soywiz.korge.input.Input
import com.soywiz.korge.view.Container
import com.soywiz.korge.view.addFixedUpdater
import com.soywiz.korge.view.addUpdater
import com.soywiz.korio.lang.Cancellable
import com.soywiz.korio.lang.cancel
import game.Game

class PlayTerminal(val game: Game, val input: Input) : Container() {
    private var cancelTick: Cancellable? = null
    private var cancelFrame: Cancellable? = null
    private var fullScreen = false

    val terminal = terminal(game.font, 80, 25)

    init {
        terminal.scaleX = 2.0
        terminal.scaleY = 4.0

        terminal.onMouseDownChar = {
            game.mouseDownChar(it)
        }

        terminal.onMouseUpChar = {
            game.mouseUpChar(it)
        }

        terminal.onMouseEnterChar = {
            game.mouseEnterChar(it)
        }

        terminal.onMouseExitChar = {
            game.mouseExitChar(it)
        }
    }

    fun startPlay() {
        game.renderAll(terminal)
        cancelTick = addFixedUpdater(18.milliseconds) {
            game.tick(terminal, input)
            if (fullScreen != game.settings.fullScreen) {
                stage?.gameWindow?.fullscreen = game.settings.fullScreen
                fullScreen = game.settings.fullScreen
            }
        }

        cancelFrame = addUpdater {
            game.frame(terminal, input)
        }
    }

    fun stopPlay() {
        cancelTick?.cancel()
        cancelTick = null

        cancelFrame?.cancel()
        cancelFrame = null
    }

    val isPlaying: Boolean
        get() = cancelTick != null
}
